"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyCoverageCatalog = void 0;
function makeEmptyCoverageCatalog() {
    return {
        id: -1,
        code: '',
        name: '',
        applyDeductible: false,
        enableUI: true,
        limits: [],
        minCost: 0,
        maxCost: 0,
        type: {
            id: -1,
            code: '',
            name: '',
        },
    };
}
exports.makeEmptyCoverageCatalog = makeEmptyCoverageCatalog;
//# sourceMappingURL=CoverageCatalog.js.map